@if (product$ | async; as product) {
  <section class="product-identifiers__section">
    <span class="product-identifiers__label">{{ "productDetails.uigArticleNumber" | cxTranslate }}:</span>
    <span class="product-identifiers__data">{{ product.code }}</span>
  </section>
  <section class="product-identifiers__section">
    <span class="product-identifiers__label">{{ "product.ean" | cxTranslate }} </span>
    <span class="product-identifiers__data">{{ product.ean }}</span>
  </section>
  <section class="product-identifiers__section">
    <span class="product-identifiers__label">{{ "productDetails.supplierArticleNumber" | cxTranslate }}:</span>
    <span class="product-identifiers__data">{{ product.supplierArticleNumber }}</span>
  </section>
}
